import {
    FlightRequestActionTypes,
    CONFIRM_OFFER_FLIGHT_REQUEST_SUCCESS,
    CONFIRM_OFFER_FLIGHT_REQUEST_FAILURE,
    CONFIRM_OFFER_FLIGHT_REQUEST_CLEAR,
    AIRLINE_FINAL_REJECT_FLIGHT_REQUEST_SUCCESS,
    AIRLINE_FINAL_REJECT_FLIGHT_REQUEST_FAILURE,
    AIRLINE_FINAL_REJECT_FLIGHT_REQUEST_CLEAR,
    AIRLINE_REQUEST_AFTER_REJECTION_SUCCESS,
    AIRLINE_REQUEST_AFTER_REJECTION_FAILURE,
    AIRLINE_REQUEST_AFTER_REJECTION_CLEAR,
} from './types';

export function confirmOfferFlightRequest(state = [], action: FlightRequestActionTypes) {
    switch (action.type) {
        case CONFIRM_OFFER_FLIGHT_REQUEST_SUCCESS:
            return action.payload;
        case CONFIRM_OFFER_FLIGHT_REQUEST_FAILURE:
            return action.payload;
        case CONFIRM_OFFER_FLIGHT_REQUEST_CLEAR:
            return action.payload;
        default:
            return state;
    }
}

export function airlineFinalRejectionFlightRequest(state = [], action: FlightRequestActionTypes) {
    switch (action.type) {
        case AIRLINE_FINAL_REJECT_FLIGHT_REQUEST_SUCCESS:
            return action.payload;
        case AIRLINE_FINAL_REJECT_FLIGHT_REQUEST_FAILURE:
            return action.payload;
        case AIRLINE_FINAL_REJECT_FLIGHT_REQUEST_CLEAR:
            return action.payload;
        default:
            return state;
    }
}

export function airlineRequestAfterRejection(state = [], action: FlightRequestActionTypes) {
    switch (action.type) {
        case AIRLINE_REQUEST_AFTER_REJECTION_SUCCESS:
            return action.payload;
        case AIRLINE_REQUEST_AFTER_REJECTION_FAILURE:
            return action.payload;
        case AIRLINE_REQUEST_AFTER_REJECTION_CLEAR:
            return action.payload;
        default:
            return state;
    }
}
